"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibError = void 0;
var LibError;
(function (LibError) {
    var Type;
    (function (Type) {
        Type["Unknown"] = "unknown_error";
        Type["Request"] = "request_error";
        Type["Params"] = "params_error";
        Type["PopUp"] = "pop_up";
        Type["VerificationRequired"] = "verification_required";
    })(Type = LibError.Type || (LibError.Type = {}));
    var Status;
    (function (Status) {
        Status["NoProviderFound"] = "DEVCODE_ERR_DECLINED_NO_PROVIDER_FOUND";
        Status["PatchPlayerFieldsError"] = "PATCH_PLAYER_FIELDS_ERROR";
        Status["InitiateInvoiceError"] = "INITIATE_INVOICE_ERROR";
        Status["PaymentProcessingError"] = "PAYMENT_PROCESSING_ERROR";
        Status["FinteqhubSeamlessUnknownError"] = "FINTEQHUB_SEAMLESS_UNKNOWN_ERROR";
        Status["RenderError"] = "RENDER_ERROR";
        Status["ValidateProfileError"] = "VALIDATE_PROFILE_ERROR";
    })(Status = LibError.Status || (LibError.Status = {}));
})(LibError = exports.LibError || (exports.LibError = {}));
